import { render, staticRenderFns } from "./TreatmentForm2.vue?vue&type=template&id=49534226&scoped=true"
import script from "./TreatmentForm2.vue?vue&type=script&lang=js"
export * from "./TreatmentForm2.vue?vue&type=script&lang=js"
import style0 from "./TreatmentForm2.vue?vue&type=style&index=0&id=49534226&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49534226",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\daima\\daima\\health-store\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('49534226')) {
      api.createRecord('49534226', component.options)
    } else {
      api.reload('49534226', component.options)
    }
    module.hot.accept("./TreatmentForm2.vue?vue&type=template&id=49534226&scoped=true", function () {
      api.rerender('49534226', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/business/page/treatment/treatment/treatment/TreatmentForm2.vue"
export default component.exports